/* store-reviews.js — «ماذا يقول قرّاؤنا» بالرئيسية (2026-10-30)
   تبويبين (تقييمات الكتب / تقييمات المتجر). التقييمات تنجاب من Judge.me كـHTML،
   وننقرا منها البيانات بـDOMParser (ما يشغّل أي سكربت)، ونرسمها بتصميم الثيم كنص فقط. */
(() => {
  if (customElements.get('asoule-store-reviews')) return;

  const MONTHS = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
  const LIST_API = 'https://api.judge.me/reviews/all_reviews_js_based';
  const SEND_API = 'https://judge.me/api/v1/reviews';
  const TYPES = { product: 'product-reviews', shop: 'shop-reviews' };

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const CHECK = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12 5 5 9-10"/></svg>';
  const textWithBreaks = (node) => {
    if (!node) return '';
    const c = node.cloneNode(true);
    c.querySelectorAll('br').forEach((b) => b.replaceWith('\n'));
    c.querySelectorAll('p').forEach((p) => p.append('\n'));
    return (c.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
  };

  class AsouleStoreReviews extends HTMLElement {
    connectedCallback() {
      this.shop = this.dataset.shop;
      this.shopName = this.dataset.shopName || '';
      this.perPage = parseInt(this.dataset.perPage, 10) || 6;
      this.arabicNum = this.dataset.num === 'arabic';
      this.note = this.querySelector('[data-note]');
      this.state = {};
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));

      this.tabs.forEach((t) => {
        t.addEventListener('click', () => this.select(t.dataset.tab));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const i = this.tabs.indexOf(t);
          const rtl = getComputedStyle(this).direction === 'rtl';
          const step = (e.key === 'ArrowLeft') === rtl ? 1 : -1;
          const next = this.tabs[(i + step + this.tabs.length) % this.tabs.length];
          next.focus();
          this.select(next.dataset.tab);
        });
      });
      this.tabs.forEach((t) => t.setAttribute('tabindex', t.getAttribute('aria-selected') === 'true' ? '0' : '-1'));

      this.querySelectorAll('[data-panel]').forEach((panel) => {
        const key = panel.dataset.panel;
        this.state[key] = { panel, page: 0, loaded: false, shown: 0, total: parseInt(panel.dataset.total, 10) || 0 };
        const more = panel.querySelector('[data-more]');
        if (more) more.addEventListener('click', () => this.load(key));
      });

      this.dialog = this.querySelector('dialog.prv-form');
      this.querySelectorAll('[data-open-form]').forEach((b) => b.addEventListener('click', () => this.openForm()));
      if (this.dialog) this.setupForm();

      const first = (this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0]).dataset.tab;
      // نجيب التقييمات لما القسم يقرّب من الشاشة، عشان ما نثقّل أول تحميل للصفحة
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { io.disconnect(); this.load(first); }
        }, { rootMargin: '400px 0px' });
        io.observe(this);
      } else {
        this.load(first);
      }
    }

    num(v) {
      const s = String(v);
      return this.arabicNum ? s.replace(/\d/g, (d) => '٠١٢٣٤٥٦٧٨٩'[d]) : s;
    }

    fmtDate(raw) {
      if (!raw) return '';
      const d = new Date(String(raw).replace(' UTC', 'Z').replace(' ', 'T'));
      if (isNaN(d)) return '';
      return `${this.num(d.getUTCDate())} ${MONTHS[d.getUTCMonth()]} ${this.num(d.getUTCFullYear())}`;
    }

    select(key) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      Object.entries(this.state).forEach(([k, s]) => { s.panel.hidden = k !== key; });
      if (this.state[key] && !this.state[key].loaded) this.load(key);
    }

    async load(key) {
      const s = this.state[key];
      if (!s || s.busy) return;
      s.busy = true;
      const list = s.panel.querySelector('[data-list]');
      const more = s.panel.querySelector('[data-more]');
      const label = more && more.querySelector('[data-more-label]');
      const page = s.page + 1;
      if (more && s.loaded) { more.disabled = true; label.textContent = 'لحظة…'; }
      try {
        const url = `${LIST_API}?url=${encodeURIComponent(this.shop)}&shop_domain=${encodeURIComponent(this.shop)}&platform=shopify&page=${page}&per_page=${this.perPage}&review_type=${TYPES[key]}`;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const doc = new DOMParser().parseFromString(String(data.html || ''), 'text/html');
        const nodes = Array.from(doc.querySelectorAll('.jdgm-rev'));
        if (!s.loaded) { list.textContent = ''; list.removeAttribute('aria-busy'); }
        let added = 0;
        nodes.forEach((n) => {
          const r = this.read(n);
          if (!r || r.author === this.shopName) return;
          list.appendChild(this.render(r, key));
          added += 1;
        });
        s.loaded = true;
        s.page = page;
        s.shown += nodes.length;
        if (typeof data.number_of_product_reviews === 'number' && key === 'product') s.total = data.number_of_product_reviews;
        if (typeof data.number_of_shop_reviews === 'number' && key === 'shop') s.total = data.number_of_shop_reviews;
        const empty = s.panel.querySelector('[data-empty]');
        if (empty) empty.hidden = list.children.length > 0;
        if (more) {
          const done = !nodes.length || s.shown >= s.total;
          more.hidden = done;
          more.disabled = false;
          if (label) label.textContent = 'عرض تقييمات أكثر';
        }
        if (page > 1) this.say(`انضافت ${this.num(added)} تقييمات`);
      } catch (e) {
        if (!s.loaded) {
          list.textContent = '';
          list.removeAttribute('aria-busy');
          const empty = s.panel.querySelector('[data-empty]');
          if (empty) { empty.textContent = 'ما قدرنا نجيب التقييمات الحين، حدّث الصفحة بعد شوي.'; empty.hidden = false; }
        } else if (more) {
          more.disabled = false;
          if (label) label.textContent = 'جرّب مرة ثانية';
        }
      } finally {
        s.busy = false;
      }
    }

    read(n) {
      const q = (sel) => n.querySelector(sel);
      const ratingEl = q('.jdgm-rev__rating');
      const rating = Number(ratingEl && ratingEl.getAttribute('data-score')) || 0;
      if (!rating) return null;
      const link = q('a.jdgm-rev__prod-link');
      const href = link ? link.getAttribute('href') || '' : '';
      let picEls = Array.from(n.querySelectorAll('.jdgm-rev__pics a'));
      if (!picEls.length) picEls = Array.from(n.querySelectorAll('.jdgm-rev__pics img'));
      const pics = picEls
        .map((a) => a.getAttribute('data-mfp-src') || a.getAttribute('href') || a.getAttribute('data-src') || a.getAttribute('src') || '')
        .filter((u) => /^https:\/\//.test(u));
      const replyEl = q('.jdgm-rev__reply-content') || q('.jdgm-rev__reply .jdgm-rev__body');
      const ts = q('.jdgm-rev__timestamp');
      return {
        rating,
        author: (q('.jdgm-rev__author') || {}).textContent ? q('.jdgm-rev__author').textContent.trim() : '',
        initial: (q('.jdgm-rev__icon') || {}).textContent ? q('.jdgm-rev__icon').textContent.trim() : '',
        verified: n.getAttribute('data-verified-buyer') === 'true',
        date: ts ? (ts.getAttribute('data-content') || ts.getAttribute('datetime') || '') : '',
        title: (q('.jdgm-rev__title') || {}).textContent ? q('.jdgm-rev__title').textContent.trim() : '',
        body: textWithBreaks(q('.jdgm-rev__body')),
        productTitle: link && /^\/products\//.test(href) ? link.textContent.trim() : '',
        productUrl: /^\/products\/[\w%-]+$/.test(href) ? href : '',
        pics: Array.from(new Set(pics)),
        reply: replyEl ? textWithBreaks(replyEl) : '',
      };
    }

    render(r, key) {
      const li = el('li', 'prv-item srv-item');
      const head = el('div', 'prv-item__head');
      const av = el('span', 'prv-item__avatar', r.initial || (r.author || '؟').charAt(0));
      av.setAttribute('aria-hidden', 'true');
      head.appendChild(av);
      const who = el('div', 'prv-item__who');
      who.appendChild(el('span', 'prv-item__name', r.author));
      if (r.verified) {
        const v = el('span', 'prv-item__verified');
        v.insertAdjacentHTML('afterbegin', CHECK);
        v.appendChild(document.createTextNode('مشتري موثّق'));
        who.appendChild(v);
      }
      head.appendChild(who);
      li.appendChild(head);

      const meta = el('div', 'prv-item__meta');
      const stars = el('span', 'prv-stars');
      stars.style.setProperty('--pct', `${r.rating * 20}%`);
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${r.rating} من ٥`);
      meta.appendChild(stars);
      meta.appendChild(el('span', null, this.fmtDate(r.date)));
      li.appendChild(meta);

      if (key === 'product' && r.productTitle) {
        const about = el('p', 'srv-item__about', 'عن: ');
        if (r.productUrl) {
          const a = el('a', null, r.productTitle);
          a.href = r.productUrl;
          about.appendChild(a);
        } else {
          about.appendChild(document.createTextNode(r.productTitle));
        }
        li.appendChild(about);
      }
      if (r.title) li.appendChild(el('p', 'prv-item__title', r.title));
      if (r.body) li.appendChild(el('p', 'prv-item__body', r.body));
      if (r.pics.length) {
        const wrap = el('div', 'prv-item__pics');
        r.pics.slice(0, 4).forEach((u) => {
          const a = el('a', 'prv-item__pic');
          a.href = u;
          a.target = '_blank';
          a.rel = 'noopener nofollow';
          const img = el('img');
          img.src = u.replace(/width=\d+/, 'width=200');
          img.alt = `صورة من تقييم ${r.author}`;
          img.loading = 'lazy';
          img.width = 88;
          img.height = 88;
          a.appendChild(img);
          wrap.appendChild(a);
        });
        li.appendChild(wrap);
      }
      if (r.reply) {
        const reply = el('div', 'prv-item__reply');
        reply.appendChild(el('span', 'prv-item__reply-by', `ردّ ${this.shopName}`));
        reply.appendChild(el('p', null, r.reply));
        li.appendChild(reply);
      }
      return li;
    }

    say(text) {
      if (!this.note) return;
      this.note.textContent = text;
      this.note.hidden = false;
      clearTimeout(this._t);
      this._t = setTimeout(() => { this.note.hidden = true; }, 4000);
    }

    /* ---------- نموذج تقييم المتجر ---------- */
    openForm() {
      if (!this.dialog) return;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('prv-lock');
    }

    closeForm() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
    }

    setupForm() {
      const dlg = this.dialog;
      this.form = dlg.querySelector('[data-form]');
      this.done = dlg.querySelector('[data-done]');
      this.err = dlg.querySelector('[data-error]');
      this.sendBtn = dlg.querySelector('[data-send]');
      dlg.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.closeForm()));
      dlg.addEventListener('click', (e) => { if (e.target === dlg) this.closeForm(); });
      dlg.addEventListener('close', () => {
        document.documentElement.classList.remove('prv-lock');
        if (!this.done.hidden) {
          this.form.reset();
          this.form.hidden = false;
          this.done.hidden = true;
        }
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.send(); });
    }

    showError(text, field) {
      this.err.textContent = text;
      this.err.hidden = false;
      if (field) field.focus();
    }

    async send() {
      const f = this.form;
      const data = new FormData(f);
      const rating = Number(data.get('rating'));
      const body = String(data.get('body') || '').trim();
      const name = String(data.get('name') || '').trim();
      const email = String(data.get('email') || '').trim();
      this.err.hidden = true;
      if (!rating) return this.showError('اختر عدد النجوم.', f.querySelector('input[name="rating"]'));
      if (body.length < 3) return this.showError('اكتب رأيك بتجربتك.', f.elements.body);
      if (!name) return this.showError('اكتب اسمك.', f.elements.name);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.showError('اكتب إيميل صحيح.', f.elements.email);
      if (String(data.get('website') || '').trim()) return this.finish();

      // بدون رقم منتج = تقييم للمتجر نفسه
      const params = new URLSearchParams({ shop_domain: this.shop, platform: 'shopify', name, email, rating: String(rating), body });
      this.sendBtn.disabled = true;
      this.sendBtn.setAttribute('aria-busy', 'true');
      const oldLabel = this.sendBtn.textContent;
      this.sendBtn.textContent = 'قاعد نرسل…';
      try {
        const res = await fetch(SEND_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body: params.toString(),
        });
        if (!res.ok) throw new Error(res.status);
        this.finish();
      } catch (e) {
        this.showError('ما وصل التقييم، جرّب مرة ثانية بعد شوي.');
      } finally {
        this.sendBtn.disabled = false;
        this.sendBtn.removeAttribute('aria-busy');
        this.sendBtn.textContent = oldLabel;
      }
    }

    finish() {
      this.form.hidden = true;
      this.done.hidden = false;
      const ok = this.done.querySelector('[data-close]');
      if (ok) ok.focus();
    }
  }

  customElements.define('asoule-store-reviews', AsouleStoreReviews);
})();
